import React, { ReactNode, useContext, useEffect, useState } from 'react';

import ReportsContext from '@totem/components/reports/ReportsContext';
import { Report } from '@totem/components/reports/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { UI_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  children?: ReactNode;
};
const ReportsContainer = ({ children }: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<Report[]>([]);
  useEffect(() => {
    fetch(`${UI_ENDPOINT}/reports`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: Report[]) => {
        setData(result);
      })
      .then(() => {
        setIsLoading(false);
      });
  }, [userProfile.organization.id, getApiToken]);
  return (
    <ReportsContext.Provider
      value={{
        loading: isLoading,
        reports: data,
      }}
    >
      {children}
    </ReportsContext.Provider>
  );
};
export default ReportsContainer;
